import { Search } from "../../../Atoms/Icons";

// `departments`/`locations` are now { value, label } pairs from
// static/filterOptions.js (DEPARTMENTS / LOCATIONS). The <select>'s
// value is always the short `value` (what jobs.department/location store
// and what filterJobs() compares against) — the `label` is only ever
// shown to the person, never used for matching.
export default function SearchBar({
  keyword, setKeyword, department, setDepartment, location, setLocation, departments, locations,
}) {
  return (
    <section className="max-w-6xl mx-auto px-4 -mt-8 relative z-10">
      <div className="search-card p-6 md:p-8">
        <div className="grid grid-cols-1 lg:grid-cols-[1fr_auto_auto_auto] gap-3 items-center">
          <div className="search-wrap">
            <Search size={16} className="search-icon" />
            <input
              type="search"
              placeholder="Search job title or keyword"
              aria-label="Search jobs"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
            />
          </div>
          <select aria-label="Department" value={department} onChange={(e) => setDepartment(e.target.value)}>
            <option value="">All Departments</option>
            {departments.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
          </select>
          <select aria-label="Location" value={location} onChange={(e) => setLocation(e.target.value)}>
            <option value="">All Locations</option>
            {locations.map((l) => <option key={l.value} value={l.value}>{l.label}</option>)}
          </select>
        </div>
      </div>
    </section>
  );
}
